import { createApiClient } from '@nutians/api-client';

// Vite only exposes VITE_*-prefixed vars; cast avoids needing an env.d.ts entry.
const env = import.meta.env as unknown as Record<string, string | undefined>;

/**
 * Shared, typed Nutians API client.
 *
 * Defaults to the dev proxy prefix: Vite rewrites `/api/*` to
 * `http://localhost:3001/*` (see vite.config.ts), and `credentials: 'include'`
 * (set inside `createApiClient`) carries the Better-Auth session cookie.
 */
export const api = createApiClient({
  baseUrl: env.VITE_API_BASE_URL ?? '/api',
});
